import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
// import Language from "./language/language";
import ManageScreen from ".";
import ListFuel from "./manage-fuel/list-fuel";
import ListSim from "./manage-sim/list-sim";
import ListMobileOperador from "./manage-mobile-operador/list-mobile-operador";
import ListModel from "./manage-model/list-model";
import ListMarca from "./manage-marca/list-marca";
import ListEquipmentProvider from "./manage-equipment-provider/list-equipment-provider";
import ListCompany from "./manage-company/list-company";
import EmpresaPlataforma from "./manage-company/empresa-plataforma";
import ListTrackingDevice from "./manage-tracking-devide/list-tracking-device";
import EditarEmpresaPlataforma from "./manage-company/edit-company";
import ListUsers from "./manage-users/list-users";
import ListGroup from "./manage-group/list-group";
import ListSubGroup from "./manage-sub-group/list-sub-group";
import ListTipoVehiculo from "./manage-tipo-vehiculo/list-tipo-vehiculo";
import ListVoltajeBateria from "./manage-battery-voltage/list-battery-voltage";
import ListTraccion from "./manage-vehicle-traction/list-vehicle-traction";
import ListVehicle from "./manage-vehicle/list-vehicle";
import Vehicle from "./manage-vehicle/vehicle";
import ListInstalacion from "./manage-installation/list-installation";
import ListClienteSecundario from "./manage-cliente-secundario/list-cliente-secundario";
import ListSellers from "./manage-sellers/list-sellers";
import LayoutInstalacion from "../../components/layout-instalacion";
import ListInstalacionEspecifica from "./manage-installation/list-installation-especifica";
import UsuarioEmpresa from "./manage-company/usuario-empresa";
import ListCurrency from "./manage-currency/list-manage-currency";
import LayoutTrackingDevice from "../../components/layout-tracking-device";
import SettingsExcelEquipo from "./manage-tracking-devide/settings-excel-equipo";
import SettingsExcelSim from "./manage-sim/settings-excel-sim";
import LayoutSim from "../../components/layout-sim";
import Advance from "./manage-tracking-devide/advance";
import AdvanceSim from "./manage-sim/advance";
import LayoutGroup from "../../components/layout-group";
import SettingsExcelGrupo from "./manage-group/settings-excel-group";
import AdvanceGroup from "./manage-group/advance-group";
import LayoutSubGroup from "../../components/layout-sub-group";
import SettingsExcelSubGrupo from "./manage-sub-group/settings-excel-sub-group";
import AdvanceSubGroup from "./manage-sub-group/advance-sub-group";
import LayoutSellers from "../../components/layout-sellers";
import SettingsExcelSellers from "./manage-sellers/settings-excel-sellers";
import AdvanceSellers from "./manage-sellers/advance-sellers";
import LayoutMarca from "../../components/layout-marca";
import AdvanceMarca from "./manage-marca/advance-marca";
import SettingsExcelMarca from "./manage-marca/settings-excel-marca";
import LayoutModel from "../../components/layout-model";
import SettingsExcelModel from "./manage-model/settings-excel-model";
import AdvanceModel from "./manage-model/advance-model";
import LayoutTipoVehiculo from "../../components/layout-tipo-vehiculo";
import AdvanceTipoVehiculo from "./manage-tipo-vehiculo/advance-tipo-vehiculo";
import SettingsExcelTipoVehiculo from "./manage-tipo-vehiculo/settings-excel-tipo-vehiculo";
import LayoutMobileOperator from "../../components/layout-mobile-operator";
import AdvanceMobileOperator from "./manage-mobile-operador/advance-mobile-operator";
import SettingsExcelMobileOperator from "./manage-mobile-operador/settings-excel-mobile-operator";
import LayoutProveedorEquipo from "../../components/layout-proveedor-equipo";
import AdvanceProveedorEquipo from "./manage-equipment-provider/advance-proveedor-equipo";
import SettingsExcelProveedorEquipo from "./manage-equipment-provider/settings-excel-proveedor-equipo";
import LayoutVehicle from "../../components/layout-vehicle";
import AdvanceVehiculo from "./manage-vehicle/advance-vehiculo";
import SettingsExcelVehiculo from "./manage-vehicle/settings-excel-vehiculo";
import ListDocuments from "./manage-document-concept/list-documents";
import ListEventosPlataforma from "./manage-company/eventos-empresa-plataforma";

const RouterAdminister = () => {
  const { path } = useRouteMatch();
  return (
    // <LayoutConfiguracion>
    <Switch>

      <Route exact path={`${path}`}>
        <ManageScreen />
      </Route>

      <Route exact path={`${path}/manage-fuel/list-fuel`}>
        <ListFuel />
      </Route>

      <Route exact path={`${path}/manage-equipment-provider/list-equipment-provider`}>
        <LayoutProveedorEquipo>
          <ListEquipmentProvider />
        </LayoutProveedorEquipo>
      </Route>
      <Route exact path={`${path}/manage-equipment-provider/advance-proveedor-equipo`}>
        <LayoutProveedorEquipo>
          <AdvanceProveedorEquipo />
        </LayoutProveedorEquipo>
      </Route>
      <Route exact path={`${path}/manage-equipment-provider/settings-excel-proveedor-equipo`}>
        <LayoutProveedorEquipo>
          <SettingsExcelProveedorEquipo />
        </LayoutProveedorEquipo>
      </Route>

      <Route exact path={`${path}/manage-mobile-operador/list-mobile-operador`}>
        <LayoutMobileOperator>
          <ListMobileOperador />
        </LayoutMobileOperator>
      </Route>
      <Route exact path={`${path}/manage-mobile-operador/advance-mobile-operator`}>
        <LayoutMobileOperator>
          <AdvanceMobileOperator />
        </LayoutMobileOperator>
      </Route>
      <Route exact path={`${path}/manage-mobile-operador/settings-excel-mobile-operator`}>
        <LayoutMobileOperator>
          <SettingsExcelMobileOperator />
        </LayoutMobileOperator>
      </Route>

      <Route exact path={`${path}/manage-marca/list-marca`}>
        <LayoutMarca>
          <ListMarca />
        </LayoutMarca>
      </Route>
      <Route exact path={`${path}/manage-marca/advance-marca`}>
        <LayoutMarca>
          <AdvanceMarca />
        </LayoutMarca>
      </Route>
      <Route exact path={`${path}/manage-marca/settings-excel-marca`}>
        <LayoutMarca>
          <SettingsExcelMarca />
        </LayoutMarca>
      </Route>

      <Route exact path={`${path}/manage-model/list-model`}>
        <LayoutModel>
          <ListModel />
        </LayoutModel>
      </Route>
      <Route exact path={`${path}/manage-model/advance-model`}>
        <LayoutModel>
          <AdvanceModel />
        </LayoutModel>
      </Route>
      <Route exact path={`${path}/manage-model/settings-excel-model`}>
        <LayoutModel>
          <SettingsExcelModel />
        </LayoutModel>
      </Route>

      <Route exact path={`${path}/manage-sim/list-sim`}>
        <LayoutSim>
          <ListSim />
        </LayoutSim>
      </Route>
      <Route exact path={`${path}/manage-sim/settings-sim`}>
        <LayoutSim>
          <SettingsExcelSim />
        </LayoutSim>
      </Route>
      <Route exact path={`${path}/manage-sim/advance-sim`}>
        <LayoutSim>
          <AdvanceSim />
        </LayoutSim>
      </Route>

      <Route exact path={`${path}/manage-company/list-company`}>
        <ListCompany />
      </Route>
      <Route exact path={`${path}/manage-company/empresa-plataforma`}>
        <EmpresaPlataforma />
      </Route>
      <Route exact path={`${path}/manage-company/eventos-empresa-plataforma`}>
        <ListEventosPlataforma />
      </Route>
      <Route exact path={`${path}/manage-company/editar-empresa-plataforma`}>
        <EditarEmpresaPlataforma />
      </Route>
      <Route exact path={`${path}/manage-company/usuario-empresa`}>
        <UsuarioEmpresa />
      </Route>
      <Route exact path={`${path}/manage-users/list-users`}>
        <ListUsers />
      </Route>

      <Route exact path={`${path}/manage-group/list-group`}>
        <LayoutGroup>
          <ListGroup />
        </LayoutGroup>
      </Route>
      <Route exact path={`${path}/manage-group/settings-excel-group`}>
        <LayoutGroup>
          <SettingsExcelGrupo />
        </LayoutGroup>
      </Route>
      <Route exact path={`${path}/manage-group/advance-group`}>
        <LayoutGroup>
          <AdvanceGroup />
        </LayoutGroup>
      </Route>

      <Route exact path={`${path}/manage-sub-group/list-sub-group`}>
        <LayoutSubGroup>
          <ListSubGroup />
        </LayoutSubGroup>
      </Route>
      <Route exact path={`${path}/manage-sub-group/settings-excel-sub-group`}>
        <LayoutSubGroup>
          <SettingsExcelSubGrupo />
        </LayoutSubGroup>
      </Route>
      <Route exact path={`${path}/manage-sub-group/advance-sub-group`}>
        <LayoutSubGroup>
          <AdvanceSubGroup />
        </LayoutSubGroup>
      </Route>

      <Route exact path={`${path}/manage-tipo-vehiculo/list-tipo-vehiculo`}>
        <LayoutTipoVehiculo>
          <ListTipoVehiculo />
        </LayoutTipoVehiculo>
      </Route>
      <Route exact path={`${path}/manage-tipo-vehiculo/advance-tipo-vehiculo`}>
        <LayoutTipoVehiculo>
          <AdvanceTipoVehiculo />
        </LayoutTipoVehiculo>
      </Route>
      <Route exact path={`${path}/manage-tipo-vehiculo/settings-excel-tipo-vehiculo`}>
        <LayoutTipoVehiculo>
          <SettingsExcelTipoVehiculo />
        </LayoutTipoVehiculo>
      </Route>

      <Route exact path={`${path}/manage-tracking-device/list-tracking-device`}>
        <LayoutTrackingDevice>
          <ListTrackingDevice />
        </LayoutTrackingDevice>
      </Route>
      <Route exact path={`${path}/manage-tracking-device/settings-excel`}>
        <LayoutTrackingDevice>
          <SettingsExcelEquipo />
        </LayoutTrackingDevice>
      </Route>
      <Route exact path={`${path}/manage-tracking-device/advance`}>
        <LayoutTrackingDevice>
          <Advance />
        </LayoutTrackingDevice>
      </Route>

      <Route exact path={`${path}/manage-battery-voltage/list-battery-voltage`}>
        <ListVoltajeBateria />
      </Route>
      <Route exact path={`${path}/manage-currency/list-currency`}>
        <ListCurrency />
      </Route>

      <Route exact path={`${path}/manage-vehicle-traction/list-vehicle-traction`}>
        <ListTraccion />
      </Route>

      <Route exact path={`${path}/manage-vehicle/list-vehicle`}>
        <LayoutVehicle>
          <ListVehicle />
        </LayoutVehicle>
      </Route>
      <Route exact path={`${path}/manage-vehicle/advance-vehicle`}>
        <LayoutVehicle>
          <AdvanceVehiculo />
        </LayoutVehicle>
      </Route>
      <Route exact path={`${path}/manage-vehicle/settings-excel-vehicle`}>
        <LayoutVehicle>
          <SettingsExcelVehiculo />
        </LayoutVehicle>
      </Route>

      <Route exact path={`${path}/manage-vehicle/vehicle`}>
        <Vehicle />
      </Route>
      <Route exact path={`${path}/manage-installation/list-installation`}>
        <LayoutInstalacion>
          <ListInstalacion />
        </LayoutInstalacion>
      </Route>
      <Route exact path={`${path}/manage-installation/list-installation-specific`}>
        <LayoutInstalacion>
          <ListInstalacionEspecifica />
        </LayoutInstalacion>
      </Route>
      <Route exact path={`${path}/manage-cliente-secundario/list-cliente-secundario`}>
        <ListClienteSecundario />
      </Route>

      <Route exact path={`${path}/manage-sellers/list-sellers`}>
        <LayoutSellers>
          <ListSellers />
        </LayoutSellers>
      </Route>
      <Route exact path={`${path}/manage-sellers/settings-excel-sellers`}>
        <LayoutSellers>
          <SettingsExcelSellers />
        </LayoutSellers>
      </Route>
      <Route exact path={`${path}/manage-sellers/advance-sellers`}>
        <LayoutSellers>
          <AdvanceSellers />
        </LayoutSellers>
      </Route>

      <Route exact path={`${path}/manage-document-concept/list-documents`}>
        <ListDocuments />
      </Route>

    </Switch>
    // </LayoutConfiguracion>
  );
};

export default RouterAdminister;
